import useMetaTag from "../../utilities/use-meta-tag";

import MastheadAlt from "../../components/masthead-alt/MastheadAlt";
import VimeoPlayer from "../../components/vimeo-player/VimeoPlayer";

export default function PerkHighlights() {
  useMetaTag({ name: "robots", content: "noindex, nofollow" });

  const videoUrl =
    "https://player.vimeo.com/video/1174628002?h=2642b094aa&badge=0&autopause=0&player_id=0&app_id=58479";

  return (
    <div className="ua-recap ua-bg-primary-one ua-full-height">
      <header className="ua-recap--header">
        <MastheadAlt className="ua-recap--header--masthead" />
      </header>
      {videoUrl && (
        <div className="ua-recap--content sixteen-by-nine">
          <VimeoPlayer vimeoUrl={videoUrl} />
        </div>
      )}
    </div>
  );
}
